import { render, staticRenderFns } from "./SelectedConvoSection.vue?vue&type=template&id=36786f15&scoped=true&"
import script from "./SelectedConvoSection.vue?vue&type=script&lang=js&"
export * from "./SelectedConvoSection.vue?vue&type=script&lang=js&"
import style0 from "./SelectedConvoSection.vue?vue&type=style&index=0&id=36786f15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36786f15",
  null
  
)

export default component.exports